// if the page name can't be passed down, figure it out
export function getPageName() {
  // Given the path "/statistics/subusers/compare",
  // it will return "statistics subusers compare"
  return window.location.pathname.replace(/[\/_-]/g, ' ').trim();
}
